import { apiIntegrationSection } from "@/presentation/data/docs/api-integration.docs";
import { architectureSection } from "@/presentation/data/docs/architecture.docs";
import { buildDeploySection } from "@/presentation/data/docs/build-deploy.docs";
import type { DocsPage, DocsSection } from "@/presentation/data/docs/docs-content.types";
import { environmentsSection } from "@/presentation/data/docs/environments.docs";
import { erpnextSection } from "@/presentation/data/docs/erpnext.docs";
import { gettingStartedSection } from "@/presentation/data/docs/getting-started.docs";
import { referenceSection } from "@/presentation/data/docs/reference.docs";

/**
 * Ordered topic sections — the growable IA skeleton. Add a new page by editing
 * the relevant `*.docs.ts` section, or add a whole section here. Organize by
 * topic/context, never by milestone.
 */
export const docsSections: DocsSection[] = [
  gettingStartedSection,
  architectureSection,
  environmentsSection,
  apiIntegrationSection,
  erpnextSection,
  buildDeploySection,
  referenceSection,
];

/** The page shown when no `?page=` is set. */
export const defaultDocsSlug = "introduction";

export function findDocsPage(slug: string): DocsPage | null {
  for (const section of docsSections) {
    const page = section.pages.find((p) => p.slug === slug);
    if (page) return page;
  }
  return null;
}

export interface DocsPageLocation {
  section: DocsSection;
  page: DocsPage;
}

/** Flat, in-order list used for prev/next navigation. */
export function flattenDocsPages(): DocsPageLocation[] {
  const out: DocsPageLocation[] = [];
  for (const section of docsSections) {
    for (const page of section.pages) {
      out.push({ section, page });
    }
  }
  return out;
}
